import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "copyButton"]
  static values = {
    url: String
  }

  copy() {
    let originalIcon = this.copyButtonTarget.innerHTML
    const lines = this.contentTarget.querySelectorAll("[class^=\"line-\"]")

    if (lines.length) {
      // Code blocks with line numbers have extra <div class="line-N">
      // which creates newline breaks in innerText. Thus we extract
      // lines one by one in a string.
      let codeText = ""

      codeText = Array.from(lines)
        .map(line => line.textContent.replace(/\n$/g, ""))
        .join("\n")

      navigator.clipboard.writeText(codeText)
    } else if (!this.contentTarget.innerText) {
      // We target the Value when it relates to a specific Input
      // otherwise we can simply access the content with innerText
      navigator.clipboard.writeText(this.contentTarget.value)
    } else {
      navigator.clipboard.writeText(this.contentTarget.innerText)
    }
    this.copyButtonTarget.innerHTML = "Copied"
    this.copyButtonTarget.setAttribute("disabled", true)

    setTimeout(() => {
      this.copyButtonTarget.innerHTML = originalIcon
      this.copyButtonTarget.removeAttribute("disabled")
    }, 2000)
  }

  async copyFromUrl(event) {
    event.preventDefault()

    try {
      const response = await fetch(this.urlValue)
      if (!response.ok) {
        console.error(`Failed to fetch: ${response.status} ${response.statusText}`)

        return
      }
      const textContent = await response.text()
      await navigator.clipboard.writeText(textContent)
    } catch (error) {
      console.error("Error copying text content:", error)

      return
    }
  }
}
